import { render, staticRenderFns } from "./Pricings.vue?vue&type=template&id=503e1c87"
import script from "./Pricings.vue?vue&type=script&lang=js"
export * from "./Pricings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports